export default ["M20 3.02l-20 7 20 7-5-7z"];
//# sourceMappingURL=direction-left.js.map